import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../assets/icons/personal-calendar.svg'


const _withScopeId = n => (_pushScopeId("data-v-4805cef9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sole-trader-data-wrapper !tw-mt-0 rmd:!tw-mt-8 rmd:!tw-w-[50%] md:!tw-h-full" }
const _hoisted_2 = {
  key: 0,
  class: "form__wrapper md:!tw-h-full"
}
const _hoisted_3 = { class: "modal_input_wrapper !tw-m-0 tw-flex tw-flex-col" }
const _hoisted_4 = { class: "modal_input !tw-m-0" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "input-lbl" }, "Insurance Type", -1))
const _hoisted_6 = { class: "custom_dropdown" }
const _hoisted_7 = { class: "modal_input_start !tw-m-0" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "input-lbl" }, "Coverage £", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "£", -1))
const _hoisted_10 = { class: "modal_input !tw-m-0" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "input-lbl" }, "Expiry date", -1))
const _hoisted_12 = ["onClick"]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "tw-cursor-pointer",
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_14 = { class: "modal_input !tw-m-0" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "  Uploading file...", -1))
const _hoisted_17 = { key: 0 }
const _hoisted_18 = {
  key: 1,
  class: "!tw-w-full"
}
const _hoisted_19 = { class: "insurances-list !tw-mt-4 rmd:!tw-mt-0 !tw-flex !tw-flex-col tw-gap-5" }
const _hoisted_20 = {
  key: 0,
  class: "insurances-list__innner"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_v_file_input = _resolveComponent("v-file-input")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_ItemListCard = _resolveComponent("ItemListCard")!
  const _component_WizardModal = _resolveComponent("WizardModal")!

  return (_openBlock(), _createBlock(_component_WizardModal, {
    hideFooter: true,
    hideBackButton: true,
    singleData: $setup.modelDetails,
    onOnClose: $setup.onClickBackButton
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        ($setup.isShowInsuranceForm)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_component_v_form, {
                onSubmit: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["prevent"])),
                rules: $setup.validation,
                ref: "insuranceFormRef",
                class: "tw-gap-4"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                      _hoisted_5,
                      _createElementVNode("div", _hoisted_6, [
                        _createVNode(_component_v_select, {
                          items: $setup.insurancesList,
                          "item-title": "name",
                          "item-value": "id",
                          modelValue: $setup.insuranceForm.type,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.insuranceForm.type) = $event)),
                          variant: "outlined",
                          class: "c-select mb-2",
                          density: "compact",
                          placeholder: "e.g Plumbing & Heating",
                          "center-affix": true,
                          "single-line": true,
                          "menu-props": { contentClass: 'tags_dropdown' }
                        }, null, 8, ["items", "modelValue"]),
                        ($setup.insuranceForm.type === $setup.getOthersId)
                          ? (_openBlock(), _createBlock(_component_v_text_field, {
                              key: 0,
                              density: "compact",
                              rules: $setup.validation.typeText,
                              placeholder: "E.g. Public liability",
                              variant: "outlined",
                              modelValue: $setup.customType,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.customType) = $event)),
                              class: "c-input rounded-full tw-flex-row-reverse mt-4 mb-2"
                            }, null, 8, ["rules", "modelValue"]))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_7, [
                      _hoisted_8,
                      _createVNode(_component_v_text_field, {
                        class: "c-input rounded-full",
                        density: "compact",
                        rules: $setup.validation.coverage,
                        modelValue: $setup.formattedCoverage,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.formattedCoverage) = $event)),
                        variant: "outlined",
                        placeholder: "E.g. £5,000,000",
                        onBlur: $setup.formatCoverage
                      }, {
                        default: _withCtx(() => [
                          _hoisted_9
                        ]),
                        _: 1
                      }, 8, ["rules", "modelValue", "onBlur"])
                    ]),
                    _createElementVNode("div", _hoisted_10, [
                      _hoisted_11,
                      _createVNode(_component_DatePicker, {
                        modelValue: $setup.insuranceForm.expiryDate,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.insuranceForm.expiryDate) = $event)),
                        popover: true,
                        "min-date": $setup.todayDate
                      }, {
                        default: _withCtx(({ togglePopover, inputValue }) => [
                          _createElementVNode("div", {
                            class: "calendar__select",
                            onClick: () => togglePopover()
                          }, [
                            _createVNode(_component_v_text_field, {
                              value: inputValue,
                              variant: "outlined",
                              placeholder: "Choose Date",
                              class: "c-input rounded-full c-input-date",
                              color: "#0C0F4A"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_13
                              ]),
                              _: 2
                            }, 1032, ["value"])
                          ], 8, _hoisted_12)
                        ]),
                        _: 1
                      }, 8, ["modelValue", "min-date"])
                    ]),
                    _createElementVNode("div", _hoisted_14, [
                      _createVNode(_component_v_file_input, {
                        class: "c-file !tw-m-0",
                        label: 
                    $setup.insuranceForm.attachments[0]?.originalName
                      ? $setup.insuranceForm.attachments[0]?.originalName
                      : `Upload`
                  ,
                        "prepend-icon": "mdi-upload",
                        variant: "solo",
                        flat: "",
                        "onClick:clear": $setup.clearAttachments,
                        onChange: $setup.onFileChange,
                        "error-messages": $setup.attachmentError
                      }, null, 8, ["label", "onClick:clear", "onChange", "error-messages"])
                    ]),
                    ($setup.isFileUploading)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                          _createVNode(_component_v_progress_linear, {
                            "model-value": $setup.uploadProgress,
                            height: 10,
                            width: 5,
                            striped: "",
                            rounded: "",
                            color: "#0C0F4A"
                          }, null, 8, ["model-value"]),
                          _createTextVNode(" " + _toDisplayString($setup.uploadProgress) + " %", 1),
                          _hoisted_16,
                          ($setup.insuranceForm.attachments.length && !$setup.isFileUploading)
                            ? (_openBlock(), _createBlock(_component_v_list, { key: 0 }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.insuranceForm.attachments, (attachment) => {
                                    return (_openBlock(), _createBlock(_component_v_list_item, {
                                      key: attachment.id,
                                      title: attachment.originalName
                                    }, {
                                      append: _withCtx(() => [
                                        _createVNode(_component_v_btn, {
                                          color: "grey-lighten-1",
                                          icon: "mdi-close-circle-outline",
                                          variant: "text",
                                          onClick: $setup.removeAttachmentFile
                                        }, null, 8, ["onClick"])
                                      ]),
                                      _: 2
                                    }, 1032, ["title"]))
                                  }), 128))
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode(_component_v_btn, {
                    class: _normalizeClass(["button disabled !tw-w-full", { 'button-orange': !$setup.isSaveButtonDisable }]),
                    onClick: $setup.onClickInsuranceNext,
                    disabled: $setup.isSaveButtonDisable
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString($setup.isEditMode ? "Update" : "Next") + "  ", 1),
                      ($setup.isInsuranceFormSubmit)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                            _createVNode(_component_v_progress_circular, {
                              indeterminate: "",
                              size: 20
                            })
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["onClick", "class", "disabled"])
                ]),
                _: 1
              }, 8, ["rules"])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                ($setup.userInsurances.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.userInsurances, (insurance) => {
                        return (_openBlock(), _createBlock(_component_ItemListCard, {
                          key: insurance.id,
                          isShowEditButton: true,
                          isShowDeleteButton: true,
                          onClickDelete: () => $setup.onDeleteInsurance(insurance.id),
                          onClickEdit: () => $setup.onEditInsurance(insurance)
                        }, {
                          listItemCardTitle: _withCtx(() => [
                            _createTextVNode(_toDisplayString(insurance?.metadata?.insuranceName ||
                  insurance?.insurance?.name), 1)
                          ]),
                          listItemCardLabel: _withCtx(() => [
                            _createTextVNode("Coverage: £" + _toDisplayString($setup.formatSum(insurance?.metadata?.sum)), 1)
                          ]),
                          listItemCardText: _withCtx(() => [
                            _createTextVNode("Expiry: " + _toDisplayString($setup.formatDate(insurance?.metadata?.expiryDate)), 1)
                          ]),
                          _: 2
                        }, 1032, ["onClickDelete", "onClickEdit"]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true),
                _createVNode(_component_v_btn, {
                  class: "button button-purple-border !tw-w-full !tw-mt-4 rmd:!tw-mt-8",
                  onClick: $setup.onClickAddAnotherInsurance
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("add another insurance")
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _createVNode(_component_v_btn, {
                class: "button button-orange !tw-w-full !tw-mt-4 rmd:!tw-mt-8",
                onClick: $setup.onConfirmInsurance
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Confirm")
                ]),
                _: 1
              }, 8, ["onClick"])
            ]))
      ])
    ]),
    _: 1
  }, 8, ["singleData", "onOnClose"]))
}